import { render, staticRenderFns } from "./Missing.vue?vue&type=template&id=28791526&scoped=true&"
var script = {}
import style0 from "./Missing.vue?vue&type=style&index=0&id=28791526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28791526",
  null
  
)

export default component.exports